module.exports = __webpack_public_path__ + "static/media/entro.00b2957d.svg";